// src/components/Auth/RenewalSuccess.js
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { useUserContext } from '../../contexts/UserContext';
import './Auth.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://http://https://southamerica-east1-drecenna.cloudfunctions.net/api';

const RenewalSuccess = () => {
  const [loading, setLoading] = useState(true);
  const [sessionInfo, setSessionInfo] = useState(null);
  const [error, setError] = useState('');
  const { user, refreshSubscription } = useUserContext();
  
  const location = useLocation();
  const navigate = useNavigate();
  
  // Extrair o ID da sessão da URL
  const sessionId = new URLSearchParams(location.search).get('session_id');
  
  useEffect(() => {
    if (!sessionId) {
      setError('Sessão inválida.');
      setLoading(false);
      return;
    }

    const verifySession = async () => {
      try {
        setLoading(true);
        
        // Verificar sessão no Stripe
        const response = await axios.get(`${API_URL}/checkout-session?sessionId=${sessionId}`);
        const session = response.data;
        
        // Verificar se o pagamento foi concluído com sucesso
        if (session.payment_status !== 'paid') {
          setError('O pagamento ainda não foi confirmado. Por favor, aguarde ou entre em contato com o suporte.');
          setLoading(false);
          return;
        }

        setSessionInfo(session);
        
        // Atualizar informações de assinatura no contexto
        if (refreshSubscription) {
          await refreshSubscription();
        }
        
        setLoading(false);
      } catch (error) {
        console.error('Erro ao verificar sessão:', error);
        setError('Não foi possível verificar o pagamento. Por favor, tente novamente ou entre em contato com o suporte.');
        setLoading(false);
      }
    };

    verifySession();
  }, [sessionId, refreshSubscription]);

  if (loading) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <h2>Verificando pagamento...</h2>
          <div className="loading-spinner"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <h2>Erro</h2>
          <div className="error-message">{error}</div>
          <button onClick={() => navigate('/dashboard')} className="btn-secondary">
            Voltar para o Dashboard
          </button>
        </div>
      </div>
    );
  }

  // Mapear nomes dos planos
  const planNames = {
    personal: 'Pessoal',
    business: 'Empresarial',
    business_pro: 'Empresarial Pro'
  };

  // Determinar o tipo de plano da sessão
  const planType = sessionInfo?.metadata?.planType;

  return (
    <div className="auth-container">
      <div className="auth-card success-card">
        <div className="success-icon">✓</div>
        <h2>Renovação Confirmada!</h2>
        <p className="success-message">
          Sua assinatura do plano <strong>{planNames[planType] || 'Selecionado'}</strong> foi renovada com sucesso!
        </p>
        <p>Você pode continuar utilizando todos os recursos da sua conta.</p>
        
        <button 
          onClick={() => navigate('/dashboard')} 
          className="subscribe-button"
          style={{ marginTop: '20px' }}
        >
          Ir para o Dashboard
        </button>
        
        <div className="auth-links">
          <p className="auth-link">
            <Link to="/settings">Acessar configurações da conta</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RenewalSuccess;